export default "__VITE_ASSET__Dw4rgA7k__"